// theme.js
import { createTheme } from '@mui/material/styles';

const baseTheme = {
    typography: {
        fontWeight: '600',
        h1: {
            fontWeight: 'bold'
        },
        h2: {
            fontWeight: '600'
        },
        h3: {
            fontWeight: '500'
        },
        h4: {
            fontWeight: '400'
        },
        h5: {
            fontWeight: '400'
        },
        h6: {
            fontWeight: '400'
        },
    },
};

const lightPalette = {
    mode: 'light',
    primary: {
        main: "#336699",
        text: "#fff",
        bold: "#336699",
    },
    secondary: {
        main: "#FF4000",
        text: "#A4A9A6",
    },
    nav: {
        main: "#336699",
        link: '#000',
        hover: '#336699'
    },
    footer: {
        main: "#336699",
        link: '#fff',
        hover: '#A69F9F'
    },
    background: {
        default: "#fff",
        section: "#f7f7f7",
        card: '#fff',
        input: "#fff",
        form: "#fff",
        drawer: ''
    },
};

const getPalette = (mode) => (lightPalette);

const theme = (mode) => createTheme({ ...baseTheme, palette: getPalette(mode) });

export default theme;
